"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1914],{

/***/ 81608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-transparent.13d3aedb.png","height":120,"width":413,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEWZm5GYnJGZx1+enp6ZqpmWwGGZnJGfyGnlpE5XAAAACHRSTlNje5sKB3OMuk0f7GwAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BlYmdiZmFhZmBkZGNkYGBgAAAB5QAoNadi5AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 1914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js
var parsePhoneNumber = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/findPhoneNumbersInText.js + 11 modules
var findPhoneNumbersInText = __webpack_require__(96981);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./static/images/AWS-Logo.jpg
/* harmony default export */ var AWS_Logo = ({"src":"/_next/static/media/AWS-Logo.795fc869.jpg","height":106,"width":240,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAACAgIDAAAAAAAAAAAAAAABAwARAgQSMUH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEA/9oADAMBAAIRAxEAPwCrv01Zbas+TQfKbkAKN9XUREFrchDf/9k=","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./src/static/images/icon/logo-transparent.png
var logo_transparent = __webpack_require__(81608);
;// CONCATENATED MODULE: ./src/static/images/icon/paypal.png
/* harmony default export */ var paypal = ({"src":"/_next/static/media/paypal.292a9f6a.png","height":110,"width":319,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAANlBMVEVgbZm7zN87gbG1t6JTnMu9tZ2hTWvF09oyeLZyt9w9hreXU3DCb0x9q82nvdjh4fLJzefEel1125j9AAAAEXRSTlMHanDAaF7cCzvA1XR+aMh66pu947YAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAjSURBVHicY+DgYGdnYGBgZxBkFuDjYuPkZOBh5Wdk4mbhBQAJLQC5gkkrxQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/components/home/Footer/index.jsx









var date = new Date();







var Footer = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Footer, Component);
    var _super = (0,_create_super/* default */.Z)(Footer);
    function Footer(props) {
        (0,_class_call_check/* default */.Z)(this, Footer);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleScroll", function() {
            if (document.documentElement.scrollTop > 600) {
                document.querySelector(".tap-top").style = "display: block";
            } else {
                document.querySelector(".tap-top").style = "display: none";
            }
        });
        _this.handleScroll = _this.handleScroll.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(Footer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("scroll", this.handleScroll);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("scroll", this.handleScroll);
            }
        },
        {
            key: "onScroll",
            value: function onScroll() {
                console.log("scroll in about page");
            }
        },
        {
            key: "clickToTop",
            value: function clickToTop() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, isAuthenticated = _props.isAuthenticated, geolocation = _props.geolocation;
                var backcolor = {
                    background: "#eeeeee"
                };
                var tap_to_top = {
                    display: "none"
                };
                var facebookUrl = "https://www.facebook.com/1800battery";
                var instagramUrl = "https://instagram.com/1800battery";
                var twitterUrl = "https://twitter.com/1800battery";
                var youTubeUrl = "https://youtube.com/channel/1800battery";
                var logoDefault = logo_transparent/* default */.Z;
                var footerHeadline = "The largest Battery Marketplace in North America. Over 10,000 products, 250,000 locations, and 1,000,000 needs served. From Cars to Coin Cells we have everything available.";
                var phoneNumber = "(800)228-8379";
                var googleNumber = "tel:+18002288379";
                var emailAddress = "info@1800battery.com";
                var name = "1-800-Battery";
                if (this.props.masterProvider && this.props.masterProvider.isActive) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
                    footerHeadline = ((ref = this.props.masterProvider) === null || ref === void 0 ? void 0 : ref.footerHeadline) || footerHeadline;
                    logoDefault = ((ref1 = this.props.masterProvider) === null || ref1 === void 0 ? void 0 : ref1.imageUrl) || logoDefault;
                    facebookUrl = ((ref2 = this.props.masterProvider) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.socialSettings) === null || ref3 === void 0 ? void 0 : ref3.facebook) || facebookUrl;
                    instagramUrl = ((ref4 = this.props.masterProvider) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.socialSettings) === null || ref5 === void 0 ? void 0 : ref5.instagram) || instagramUrl;
                    twitterUrl = ((ref6 = this.props.masterProvider) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.socialSettings) === null || ref7 === void 0 ? void 0 : ref7.twitter) || twitterUrl;
                    youTubeUrl = ((ref8 = this.props.masterProvider) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.socialSettings) === null || ref9 === void 0 ? void 0 : ref9.youtube) || youTubeUrl;
                    phoneNumber = ((ref10 = this.props.masterProvider) === null || ref10 === void 0 ? void 0 : ref10.phoneNumber) || phoneNumber;
                    emailAddress = ((ref11 = this.props.masterProvider) === null || ref11 === void 0 ? void 0 : ref11.emailAddress) || emailAddress;
                    name = ((ref12 = this.props.masterProvider) === null || ref12 === void 0 ? void 0 : ref12.name) || name;
                }
                googleNumber = (0,findPhoneNumbersInText/* findPhoneNumbersInText */.t)(phoneNumber, "US");
                if (googleNumber.length > 0) {
                    googleNumber = (0,parsePhoneNumber/* parsePhoneNumber */.S)(googleNumber[0].number.number);
                    phoneNumber = googleNumber.formatNational();
                    googleNumber = googleNumber.getURI();
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                    className: "footer-light",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "section-b-space light-layout",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row footer-theme partition-f",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-4 col-md-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "footer-contant",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-logo",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/",
                                                            as: "/",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    width: "200px",
                                                                    height: "58px",
                                                                    src: logoDefault,
                                                                    alt: "footer-logo",
                                                                    className: "lazyload"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: footerHeadline
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-social",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: facebookUrl,
                                                                        "aria-label": "Facebook",
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fab fa-facebook",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: twitterUrl,
                                                                        "aria-label": "Twitter",
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fab fa-twitter",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: instagramUrl,
                                                                        "aria-label": "Instagram",
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fab fa-instagram",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: youTubeUrl,
                                                                        "aria-label": "YouTube",
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fab fa-youtube-square"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sub-title",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-title",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "MY ACCOUNT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-contant",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/dashboard",
                                                                                as: "/dashboard",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fad fa-user-cog"
                                                                                        }),
                                                                                        " Dashboard"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            className: "logout",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/logout",
                                                                                as: "/logout",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fad fa-sign-out-alt"
                                                                                        }),
                                                                                        " Logout"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/login",
                                                                                as: "/login",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fad fa-sign-in-alt"
                                                                                        }),
                                                                                        " Login"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/register",
                                                                                as: "/register",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fas fa-user-plus"
                                                                                        }),
                                                                                        " Register"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sub-title",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-title",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "QUESTIONS"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-contant",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/shipping-and-returns",
                                                                        as: "/shipping-and-returns",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Shipping & Returns"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/frequently-asked-questions",
                                                                        as: "/frequently-asked-questions",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Frequently Asked Questions"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/termsofuse",
                                                                        as: "/termsofuse",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Terms of Use"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/returnpolicy",
                                                                        as: "/returnpolicy",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Return Policy"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/disclaimers",
                                                                        as: "/disclaimers",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Disclaimers"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/privacy",
                                                                        as: "/privacy",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Privacy Policy"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        target: "_blank",
                                                                        href: "https://www.affirm.com/disclosures",
                                                                        rel: "noreferrer",
                                                                        children: "Affirm Financing Disclosure"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "#",
                                                                        class: "termly-display-preferences",
                                                                        children: "Consent Preferences"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "https://app.termly.io/notify/2512fd1e-9e4f-4d67-982b-06ada61d6399",
                                                                        class: "termly-display-preferences",
                                                                        children: "Do Not Sell or Share My Personal information"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "https://app.termly.io/notify/2512fd1e-9e4f-4d67-982b-06ada61d6399",
                                                                        class: "termly-display-preferences",
                                                                        children: "Limit the Use Of My Sensitive Personal Information"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sub-title",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-title",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Business"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-contant",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/add-a-installer",
                                                                        as: "/add-a-installer",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Become an Installer"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/category/[categoryid]",
                                                                        as: "/category/roadside-assistance",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Roadside Assistance"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/locations",
                                                                        as: "/locations",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Locations"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sub-title",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-title",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "About"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer-contant",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/about",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            children: [
                                                                                "About ",
                                                                                name
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "/cities/vehicle-batteries-car-or-truck",
                                                                        children: "Mobile Car & Truck Battery Replacement Service in Your City"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/cities/vehicle-batteries-hybrid-electric",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: "Hybrid Electric Battery Replacement"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: googleNumber,
                                                                        children: phoneNumber
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "mailto:".concat(emailAddress, "?Subject=Inquiry%20from%20Website"),
                                                                        children: emailAddress
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sub-footer ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xl-6 col-md-6 col-sm-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "footer-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "pb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa fa-copyright",
                                                            "aria-hidden": "true"
                                                        }),
                                                        "Copyright \xa9 ",
                                                        date.getFullYear(),
                                                        " ",
                                                        name,
                                                        " Inc All Rights Reserved. ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        name,
                                                        "\xae is a Registered Trademark."
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xl-6 col-md-6 col-sm-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "payment-card-bottom",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "trustedsite-trustmark",
                                                                "data-type": "212",
                                                                "data-width": "120",
                                                                "data-height": "50"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                id: "siteseal"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "#",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    width: "160px",
                                                                    height: "55px",
                                                                    src: paypal,
                                                                    alt: "Visa MasterCard American Express "
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://aws.amazon.com/what-is-cloud-computing",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    width: "120px",
                                                                    height: "53px",
                                                                    className: "lazyload",
                                                                    src: AWS_Logo,
                                                                    alt: "Powered by AWS Cloud Computing"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {})
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tap-top top-cls",
                            onClick: this.clickToTop,
                            style: tap_to_top,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa fa-angle-double-up"
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Footer;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        isAuthenticated: Boolean(state.customer && state.customer.first_name),
        customer: state.customer,
        geolocation: state.geolocation
    };
};
/* harmony default export */ var home_Footer = ((0,es/* connect */.$j)(mapStateToProps)(Footer));


/***/ })

}]);